(() => {
  const ROOT_CLASS = 'moretti-inbox-hidden';
  const OVERLAY_ROOT_SELECTOR =
    'cart-drawer, cart-notification, quick-add-modal, product-modal, details-modal, [data-moretti-precheckout], dialog';
  const VISIBLE_MODAL_SELECTORS = [
    'cart-notification.active',
    '[data-moretti-precheckout]:not([hidden]):not([aria-hidden="true"])',
    'quick-add-modal[open]',
    'product-modal[open]',
    'dialog[open]',
    '[role="dialog"][aria-modal="true"]',
  ];

  const isVisible = (element) => {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

    if (typeof element.checkVisibility === 'function') {
      return element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    }

    let current = element;
    while (current) {
      if (current.hidden || current.getAttribute?.('aria-hidden') === 'true') return false;

      const style = window.getComputedStyle(current);
      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.visibility === 'collapse' ||
        Number(style.opacity) === 0
      ) {
        return false;
      }

      current = current.parentElement;
    }

    return element.getClientRects().length > 0;
  };

  const hasCommerceOverlay = () => {
    if (document.querySelector('cart-drawer.active')) return true;
    if (document.body?.classList.contains('overflow-hidden')) return true;

    return VISIBLE_MODAL_SELECTORS.some((selector) =>
      Array.from(document.querySelectorAll(selector)).some(isVisible)
    );
  };

  let scheduled = false;

  const syncLauncherVisibility = () => {
    scheduled = false;
    document.documentElement.classList.toggle(ROOT_CLASS, hasCommerceOverlay());
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    if (typeof window.queueMicrotask === 'function') {
      window.queueMicrotask(syncLauncherVisibility);
    } else {
      Promise.resolve().then(syncLauncherVisibility);
    }
  };

  const handleOverlayTransition = (event) => {
    if (event.target instanceof Element && event.target.closest(OVERLAY_ROOT_SELECTOR)) {
      scheduleSync();
    }
  };

  const start = () => {
    syncLauncherVisibility();

    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'open', 'aria-hidden', 'aria-modal'],
    });

    document.addEventListener('toggle', scheduleSync, true);
    document.addEventListener('transitionend', handleOverlayTransition, true);
    document.addEventListener('animationend', handleOverlayTransition, true);
    document.addEventListener('shopify:section:load', scheduleSync);
    window.addEventListener('pageshow', scheduleSync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
